/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationRemoveOwnerPathParams,
	OrganisationRemoveOwnerResponse,
} from '../types/OrganisationRemoveOwner'

/**
 * DELETE /organisations/:organisation/owner
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::removeOwner
 */
export async function organisationRemoveOwner(
	organisation: OrganisationRemoveOwnerPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationRemoveOwnerResponse>> {
	return axiosInstance.delete(`/organisations/${organisation}/owner`, config)
}
